import { render } from "./CategoryAttributeGrid.vue?vue&type=template&id=042fbc06"
import script from "./CategoryAttributeGrid.vue?vue&type=script&lang=ts"
export * from "./CategoryAttributeGrid.vue?vue&type=script&lang=ts"
script.render = render

export default script